import {HttpService} from "../http.service";
import {Injectable} from "@angular/core";

@Injectable()
export class BaseApiService {
  constructor(protected httpService: HttpService) {}
}
